// extracted by mini-css-extract-plugin
export default {"container":"styles_container__A6D10","wrapper":"styles_wrapper__iaixF","guide":"styles_guide__YaCnT","logo":"styles_logo__BA8MY","message":"styles_message__rZxqS"};